import {ComplexTextFont} from 'common/src/modules/complexText/complexText.types';
import {DPMeta} from 'common/src/modules/dynamicParameters/dynamicParameters.types';

const fontsTag = document.createElement('style');
document.head.appendChild(fontsTag);

export default function loadMetaFonts(data: {meta: DPMeta}[]): void {
  const fontsToLoad: Map<string, ComplexTextFont> = new Map();

  data.forEach(({meta}) => {
    meta.comps.forEach((comp) => {
      comp.layers.forEach(({fontFileUrl, textMetadata}) => {
        if (!fontFileUrl || !textMetadata) return;
        fontsToLoad.set(textMetadata.fontName, {
          url: fontFileUrl,
          weight: textMetadata.weight.toString(),
          italic: textMetadata.isItalic,
          family: textMetadata.fontName,
        });
      });
    });
  });

  for (const [fontName, {url, weight, italic}] of fontsToLoad.entries()) {
    const fontStr = `${weight} 15px "${fontName}"`;
    if (document.fonts.check(fontStr)) continue;
    fontsTag.innerHTML += `@font-face {font-family: ${fontName};src: url('${url}') format('woff');font-weight: ${weight};font-style: ${
      italic ? 'italic' : 'normal'
    };}`;
  }
}
